import { onMounted, onUnmounted, ref } from 'vue';
import { evidenceUploadQueue, type EvidenceQueueItem } from '@/utils/evidence-upload-queue';

export function useEvidenceUploadQueue() {
  const items = ref<EvidenceQueueItem[]>([]);
  let unsubscribe: (() => void) | undefined;

  onMounted(() => {
    unsubscribe = evidenceUploadQueue.subscribe((next) => {
      items.value = next;
    });
  });
  onUnmounted(() => unsubscribe?.());

  return { items };
}
